import { ITriggerLinks } from '../../../email-builder/src/types'
import { Template, ICustomValue, ICustomField, Menu } from '../types'

export type State = {
  builderState: {} | undefined
  iframeState: {} | undefined
  templateData: Template
  apiKey: string
  userId: string
  timeZone: string
  tokenId: string
  userEmail: string
  userName: string
  userPermissions: { [key: string]: boolean }
  enableAssignToData: boolean
  retryCount: number
  customFieldsLocation: ICustomField[]
  customValuesLocation: ICustomValue[]
  triggerLinksLocation: ITriggerLinks[]
  companyId: string
  locationId: string
  emailId: string
  parentBaseUrl: string
}

export const state: State = {
  retryCount: 0,
  builderState: undefined,
  iframeState: undefined,
  templateData: {
    name: '',
    openRate: '',
    bounceRate: '',
    archived: '',
    builderVersion: '',
    fromName: '',
    fromAddress: '',
    subjectLine: '',
    previewText: '',
    lastUpdated: '',
    thumbnailImage: '',
    updatedBy: '',
    previewUrl: '',
    locationId: '',
    type: '',
  },
  userId: '',
  apiKey: '',
  tokenId: '',
  timeZone: '',
  userEmail: '',
  userName: '',
  companyId: '',
  userPermissions: {},
  enableAssignToData: false,
  customFieldsLocation: [],
  customValuesLocation: [],
  triggerLinksLocation: [],
  locationId: '',
  emailId: '',
  parentBaseUrl: '',
}
